import React from 'react';
import {motion} from 'framer-motion';

const MenuGallery = () => {
  // New images as provided by user
  const images = [
    { src: 'https://i.ibb.co/xt4fzht6/images-2.jpg' },
    { src: 'https://i.ibb.co/N61r4P60/images-4.jpg' },
    { src: 'https://i.ibb.co/jkGcJm8x/images-7.jpg' },
    { src: 'https://i.ibb.co/xqHkdGX6/images-9.jpg' },
    { src: 'https://i.ibb.co/0jhZWVDc/images-11.jpg' },
    { src: 'https://i.ibb.co/yBcXNmCq/images-13.jpg' },
    { src: 'https://i.ibb.co/VsJJYML/images-21.jpg' },
    { src: 'https://i.ibb.co/jZxNwhSb/images-23.jpg' },
    { src: 'https://i.ibb.co/G32ZnVJr/images-31.jpg' },
    { src: 'https://i.ibb.co/nNFN4zMQ/images-32.jpg' },
    { src: 'https://i.ibb.co/0RK0G7YD/images-33.jpg' },
    { src: 'https://i.ibb.co/7tM2dXhq/images-35.jpg' },
    { src: 'https://i.ibb.co/ytswLLX/images-36.jpg' },
    { src: 'https://i.ibb.co/bjzC1Kq0/images-37.jpg' },
    { src: 'https://i.ibb.co/rKPgkSfQ/images-38.jpg' },
    { src: 'https://i.ibb.co/m5wZxxm6/images-40.jpg' },
    { src: 'https://i.ibb.co/tpYjrNG4/images-43.jpg' },
    { src: 'https://i.ibb.co/LztTbWqs/images-44.jpg' },
    { src: 'https://i.ibb.co/jPzZLcXc/images-45.jpg' },
    { src: 'https://i.ibb.co/3yJJ3P2p/images-47.jpg' },
    { src: 'https://i.ibb.co/7J8RQFfv/images-49.jpg' },
    { src: 'https://i.ibb.co/BHFBmm43/images-50.jpg' },
    { src: 'https://i.ibb.co/wF7tvzM8/images-52.jpg' },
    { src: 'https://i.ibb.co/tMpgrVcM/images-53.jpg' }
  ];

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="min-h-screen">
      {/* Hero Section - Light yellow header with red circles */}
      <section className="bg-gradient-to-br from-[#ffeb3b] via-[#fff59d] to-[#ffecb3] text-black py-20 relative overflow-hidden">
        {/* Red circle templates */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 100, opacity: 0.3 }}
            transition={{ duration: 20, repeat: Infinity, repeatType: "reverse" }}
            className="absolute top-10 left-10 w-16 h-16 bg-[#ff8080] rounded-full blur-xl"
          />
          <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 50, opacity: 0.3 }}
            transition={{ duration: 15, repeat: Infinity, repeatType: "reverse" }}
            className="absolute bottom-20 right-20 w-20 h-20 bg-[#ffcc80] rounded-full blur-xl"
          />
          <motion.div
            initial={{ rotate: 0, scale: 0.8 }}
            animate={{ rotate: 360, scale: 1 }}
            transition={{ duration: 25, repeat: Infinity, repeatType: "reverse" }}
            className="absolute top-1/2 left-1/4 w-24 h-24 bg-[#ff9999] rounded-full opacity-20 blur-2xl"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 
            initial={{ y: 30, opacity: 0 }} 
            animate={{ y: 0, opacity: 1 }} 
            transition={{ delay: 0.2 }} 
            className="text-4xl md:text-5xl font-bold mb-6"
          >
            Menu Gallery
          </motion.h1>
          <motion.p 
            initial={{ y: 30, opacity: 0 }} 
            animate={{ y: 0, opacity: 1 }} 
            transition={{ delay: 0.4 }} 
            className="text-xl max-w-3xl mx-auto"
          >
            Explore our delicious selection of fresh baked goods and traditional Chinese pastries
          </motion.p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 relative overflow-hidden">
        {/* Moving elements - 30% lighter */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: -100, opacity: 0.3 }}
            transition={{ duration: 18, repeat: Infinity, repeatType: "reverse" }}
            className="absolute top-1/4 right-10 w-14 h-14 bg-[#ff9999] rounded-full blur-xl"
          />
          <motion.div
            initial={{ y: 80, opacity: 0 }}
            animate={{ y: -80, opacity: 0.3 }}
            transition={{ duration: 12, repeat: Infinity, repeatType: "reverse" }}
            className="absolute bottom-10 left-1/3 w-18 h-18 bg-[#ff8080] rounded-full blur-xl"
          />
          <motion.div
            initial={{ scale: 0.5, rotate: 0 }}
            animate={{ scale: 1, rotate: 180 }}
            transition={{ duration: 20, repeat: Infinity, repeatType: "reverse" }}
            className="absolute top-1/2 right-1/4 w-20 h-20 bg-[#ffcc80] rounded-full opacity-20 blur-2xl"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {images.map((image, index) => (
              <motion.div 
                key={image.src} 
                layout 
                initial={{ opacity: 0, scale: 0.8 }} 
                animate={{ opacity: 1, scale: 1 }} 
                transition={{ delay: index * 0.05 }} 
                className="group relative overflow-hidden rounded-lg shadow-lg bg-white"
              >
                <div className="aspect-square overflow-hidden">
                  <img 
                    src={image.src} 
                    alt={`Bakery item ${index + 1}`} 
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110" 
                    loading="lazy"
                  />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* CTA Section - Light yellow header with red circles */}
      <section className="py-16 bg-gradient-to-br from-[#ffeb3b] via-[#fff59d] to-[#ffecb3] text-black relative overflow-hidden">
        {/* Red circle templates */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <motion.div
            initial={{ scale: 0.5, rotate: 0 }}
            animate={{ scale: 1, rotate: 180 }}
            transition={{ duration: 20, repeat: Infinity, repeatType: "reverse" }}
            className="absolute top-10 left-10 w-32 h-32 bg-[#ff6666] rounded-full opacity-20 blur-3xl"
          />
          <motion.div
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: -50, opacity: 0.3 }}
            transition={{ duration: 15, repeat: Infinity, repeatType: "reverse" }}
            className="absolute bottom-20 right-1/4 w-16 h-16 bg-[#ffcc80] rounded-full blur-xl"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Visit Us Today</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">All items are made fresh daily. Come taste the difference quality makes!</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+14164659103" className="bg-red-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-red-600 transition-colors">
              Call to Order
            </a>
            <a href="https://maps.app.goo.gl/5UrwfXYobJPutNCF6" target="_blank" rel="noopener noreferrer" className="border-2 border-red-600 text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-red-600 hover:text-white transition-colors">
              Get Directions
            </a>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default MenuGallery;